import { Modal } from "antd";
import React, { ReactNode, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import styles from "./TNSuccessModal.module.scss";
import Success from "../../assets/images/accept-icon.svg";
const SuccessModal = ({
  message,
  formattedMessage,
  isWarningModalOpen,
  closeHandler,
}: {
  message?: string;
  formattedMessage?: ReactNode;
  isWarningModalOpen?: boolean;
  closeHandler?: () => void;
}) => {
  return (
    <Modal
      visible={isWarningModalOpen}
      footer={null}
      onCancel={closeHandler}
      closable={true}
      zIndex={10000}
      closeIcon={<CloseOutlined className={styles.closeIcon}/>}
    >
      <div className={styles.SuccesModalBodyContainer}>
        <img src={Success} alt="Success icon" />
        <h3>Success</h3>
        {!!message
          ? <p>{message}</p>
          : (formattedMessage)
        } 
      </div>
    </Modal>
  );
};

export default SuccessModal;
